import { useQuery } from '@tanstack/react-query'
import { queryAdvertiserByID, QueryAdvertiserByIDParams } from 'supabase/advertisers'

export const useQueryAdvertiser = (params: QueryAdvertiserByIDParams) => {
  const query = useQuery({
    queryKey: ['advertiser', `id:${params.id}`],
    queryFn: () => queryAdvertiserByID(params),
    enabled: !!params.id,
  })

  return {
    advertiser: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}